module.exports = __webpack_public_path__ + "static/media/Global Gaming Survey Report -2.5d7ba075.PNG";